<template>
  <el-dialog
    :title="dialogType == 'add' ? '新增人员信息' : '编辑人员信息'"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    width="40%"
  >
    <div class="dialog_box">
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="dataInfo"
        label-width="0px"
      >
        <div class="form-row-item-box">
          <div class="form-item-box">
            <span>用户名称:</span>
            <el-form-item prop="userName">
              <el-input
                size="small"
                clearable
                style="width:100%"
                v-model="dataInfo.userName"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item-box">
            <span>用户电话:</span>
            <el-form-item prop="userPhone">
              <el-input
                size="small"
                clearable
                style="width:100%"
                v-model="dataInfo.userPhone"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-row-item-box">
          <div class="form-item-box">
            <span>登录密码:</span>
            <el-form-item>
              <el-input
                size="small"
                clearable
                :placeholder="
                  dialogType == 'add' ? '请输入密码' : '不填写密码为原密码'
                "
                style="width:100%"
                v-model="dataInfo.userPwd"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item-box">
            <span>所属部门:</span>
            <el-form-item prop="departmentId">
              <el-select
                v-model="dataInfo.departmentId"
                size="small"
                style="width:100%"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.departmentId"
                  :label="item.departmentName"
                  :value="item.departmentId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-row-item-box">
          <!-- <div class="form-item-box" v-if="eduInfo.eduBuresuType != -1">
            <span>所属角色:</span>
            <el-form-item prop="roleId">
              <el-select
                v-model="dataInfo.roleId"
                size="small"
                style="width:100%"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div> -->
          <div class="form-item-box">
            <span>职务选择:</span>
            <el-form-item prop="officeLists">
              <el-select
                v-model="dataInfo.officeLists"
                size="small"
                style="width:100%"
                clearable
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in dutiesList"
                  :key="item.id"
                  :label="item.positionTitle"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-row-item-box">
          <div class="form-item-box">
            <span>身份证号:</span>
            <el-form-item>
              <el-input
                size="small"
                clearable
                placeholder="请输入身份证号"
                maxlength="18"
                style="width:100%"
                v-model="dataInfo.userIdNumber"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item-box">
            <span>座机号:</span>
            <el-form-item>
              <el-input
                size="small"
                clearable
                placeholder="请输入座机号"
                maxlength="24"
                style="width:100%"
                v-model="dataInfo.landlineNumber"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-row-item-box">
          <div class="form-item-box">
            <span>邮箱地址:</span>
            <el-form-item>
              <el-input
                size="small"
                clearable
                placeholder="请输入邮箱地址"
                maxlength="18"
                style="width:100%"
                v-model="dataInfo.email"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item-box">
            <span>性别选择:</span>
            <el-form-item>
              <el-radio-group size="small" v-model="dataInfo.sex">
                <el-radio-button
                  v-for="typeList in $store.state.select.personnelSex"
                  :key="typeList.id"
                  :value="typeList.id"
                  :label="typeList.id"
                  >{{ typeList.nameOne }}</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="dialog_save_cancel_box">
        <div class="cancel_item_box" @click="close">取消</div>
        <div class="save_item_box" @click="saveClick('ruleForm')">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    dialogType: {
      type: String,
      default: () => {
        return "add";
      }
    },
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    //这里存放数据
    return {
      rules: {
        userName: [{ required: true, message: " ", trigger: "blur" }],
        userPhone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        departmentId: [{ required: true, message: " ", trigger: "change" }],
        // roleId: [{ required: true, message: " ", trigger: "change" }],
        officeLists: [{ required: true, message: " ", trigger: "change" }]
      },
      show: false,
      dataInfo: {
        userId: "",
        eduId: this.$store.getters.getEduData.eduId,
        roleId: 0,
        userName: "",
        userPhone: "",
        userPwd: "",
        departmentId: "",
        userIdNumber: "",
        landlineNumber: "",
        email: "",
        sex: 0,
        officeLists: ""
      },
      departmentList: [],
      roleList: [],
      dutiesList: []
    };
  },
  //监控data中的数据变化
  watch: {
    showDialog: function(val) {
      this.show = val;
      if (val) {
        this.getDepartmentList();
        this.dataInfo = Object.assign({}, this.dialogInfo);
      }
    }
  },
  //计算属性，类似于data概念
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    },
    userInfo() {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    }
  },
  //方法集合
  methods: {
    close() {
      this.$refs.ruleForm.resetFields();
      this.$emit("close");
    },
    saveClick(formName) {
      if (this.dialogType == "add" && !this.dataInfo.userPwd) {
        this.$message({
          message: "请输入密码...",
          type: "warning"
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveClick", this.dataInfo);
        } else {
          return false;
        }
      });
    },
    async getDepartmentList() {
      let res = await this.$Http.getEduWholeDepartment({
        eduId: this.$store.getters.getEduData.eduId
      });
      if (res.code == 200) {
        this.departmentList = res.data || [];
      } else if (res.code == 101) {
        this.departmentList = [];
      } else {
        this.departmentList = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async getRoleList() {
      var requestData = {
        eduId: this.$store.getters.getEduData.eduId
      };
      let res = await this.$Http.getWholeEduRole(requestData, true);
      if (res.code == 200) {
        this.roleList = res.data || [];
      } else if (res.code == 101) {
        this.roleList = [];
      } else {
        this.roleList = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async getDutiesList() {
      var requestData = {
        pageNum: 1,
        pageSize: 99999,
        eduId: this.$store.getters.getEduData.eduId
      };
      let res = await this.$Http.getEduDitoes(requestData, true);
      if (res.code == 200) {
        this.dutiesList = res.data.list || [];
      } else if (res.code == 101) {
        this.dutiesList = [];
      } else {
        this.dutiesList = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    this.getRoleList();
    this.getDutiesList();
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
@import "../../../../../public/css/edu_pages.scss";
</style>
